import Response from "../../Data/Domain/Response";
import RepositorySdgs from "../Domain/RepositorySdgs";
import { getRepositorySdgs } from "./RepositorySdgs.service";

export async function getRepositorySdgsRepository(params) {
  const data = await getRepositorySdgs(params);
  return new Response(data, RepositorySdgs).getMultiple();
}
